import React from 'react'
import classes from './checkout.module.css'
import { Link } from 'react-router-dom'
import { AiOutlineDoubleRight } from 'react-icons/ai'
// import { Country } from '../fakeproduct/FakePorduct'
// import { RapperContent } from '../../App'
// import { useContext } from 'react'


// import Order from './Order/Order'
const Checkout = () => {
    // const { selectProduct } = useContext(RapperContent)
    // const uniqueObjects = [...new Map(selectProduct.map(item => [item.id, item])).values()]
    // let arr = []
    // selectProduct.forEach((e) => {
    //     arr = [...arr, e.price]
    // })
    // const price = arr.reduce((total, num) => total + num, 0)
    return (
        <>
            <div className={classes.checkoutForm}>
                <div className={classes.container}>
                    <div className={classes.location}>
                        <li><Link to='/'>Home</Link></li>
                        <AiOutlineDoubleRight className={classes.icon} />
                        <li><Link to='/addedProducts'>Added Products</Link></li>
                        <AiOutlineDoubleRight className={classes.icon} />
                        <li className={classes.active}>Checkout</li>
                    </div>

                    <div className={classes.checkoutContainer}>
                        <div className={classes.BilingDetails}>
                            <h6>Billing Details</h6>
                            <form>
                                <div className={classes.name}>
                                    <div>
                                        <label htmlFor="firstname">First Name <span style={{ color: 'red' }}>*</span></label>
                                        <input type="text" name="firstname" required />
                                    </div>
                                    <div>
                                        <label htmlFor="lastname">Last Name <span style={{ color: 'red' }}>*</span></label>
                                        <input type="text" name="lastname" required />
                                    </div>
                                </div>
                                <div className={classes.country}>
                                    <label htmlFor="country">Country <span style={{ color: 'red' }}>*</span></label>
                                    <select id="country" required>
                                        {/* {
                                            Country.map(cty => <option value={cty} key={cty}>{cty}</option>)
                                        } */}

                                    </select>
                                </div>
                                <div className={classes.company}>
                                    <label htmlFor="Company">Company</label>
                                    <input type="text" name="Company" />
                                </div>
                                <div className={classes.address}>
                                    <label htmlFor="address">Address <span style={{ color: 'red' }}>*</span></label>
                                    <input type="text" name="address" required />
                                </div>
                                <div className={classes.town__city}>
                                    <label htmlFor="town__city">Town / City <span style={{ color: 'red' }}>*</span></label>
                                    <input type="text" name="town__city" />
                                </div>
                                <div className={classes.post__zip}>
                                    <label htmlFor="post__zip">Post / Zip</label>
                                    <input type="text" name="post__zip" />
                                </div>
                                <div className={classes.email__phone}>
                                    <div>
                                        <label htmlFor="email">Email <span style={{ color: 'red' }}>*</span></label>
                                        <input type="email" name="email" required />
                                    </div>
                                    <div>
                                        <label htmlFor="phone">Phone <span style={{ color: 'red' }}>*</span></label>
                                        <input type="number" name="phone" required />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className={classes.yourOrder}>
                            <div className={classes.order}>
                                <h6>Your Order</h6>
                                <ul className={classes.heading}>
                                    <li>Product</li>
                                    <li>Total</li>
                                </ul>
                                <ul className={classes.allProduct}>
                                    {/* {
                                        uniqueObjects.map(pd => <Order product={pd} key={pd.id} />)
                                    } */}
                                </ul>
                                <div className={classes.subtotal}>
                                    <li>Sub-Total</li>
                                    {/* <li>${price}</li> */}
                                </div>
                                <div className={classes.cupon}>
                                    <li>Cupon</li>
                                    <li>-$50</li>
                                </div>
                                <div className={classes.shipping}>
                                    <li>Shipping</li>
                                    <li>Free Shipping</li>
                                </div>
                                <div className={classes.total}>
                                    <h6>Total</h6>
                                    {/* <h6>${price - 50}</h6> */}
                                </div>

                            </div>
                            <div className={classes.bank}>
                                <div>
                                    <input type="checkbox" name="" id="" />
                                    Direct Bank Transfer
                                </div>
                                <div>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi quas vero culpa quidem blanditiis voluptatibus nemo cupiditate pariatur atque sint.
                                </div>
                                <div>
                                    <input type="checkbox" name="" id="" />
                                    Cheque Payment
                                </div>
                                <div>
                                    <input type="checkbox" name="" id="" />
                                    PayPal
                                </div>
                                <button>Place Order</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Checkout
